import React, { useState } from 'react';
import CouponsHeader from './CouponsHeader';
import CouponsList from './CouponsList';
import { useCopyToast, useIsMobile } from '@repo/common';

const Coupons = () => {
  const isMobile = useIsMobile();
  const [currentFilter, setCurrentFilter] = useState('Active');
  const { copy, copyToast } = useCopyToast();

  return (
    <div className='flex flex-col tabletH:min-w-[790px] tabletH:max-w-[868px] w-full tabletH:pb-[60px] items-start'>
      <CouponsHeader
        currentFilter={currentFilter}
        onFilterChange={setCurrentFilter}
        $isMobile={isMobile}
      />
      <CouponsList
        currentFilter={currentFilter}
        onCopy={copy}
        $isMobile={isMobile}
      />

      {copyToast}
    </div>
  );
};

export default Coupons;
